const SearchShowAllButton = {
  template: `<div class="button-container background--yellow" v-if="show">
    <button class="button is--outlined is--blue" v-on:click="handleClick">{{title}}</button>
  </div>`,
  props: [
    'target',
    'title',
  ],
  data () {
    return {
      show: true,
    }
  },
  methods: {
    handleClick: function (event) {
      const targetElement = document.querySelector(`[${this.target}]`);
      if (targetElement) {
        targetElement.classList.remove('not-expanded');
        this.show = false;
      }
    }
  },
  created () {
    console.log(this.target);
  },
  mounted () {
  }
}

export default SearchShowAllButton;
